module.exports = __webpack_public_path__ + "p5_img1.jpg?4059b094abf243f2a56b4266fd8d201e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img1.jpg
// module id = 117
// module chunks = 0